/// <amd-module name="VSSUI/Components/Link/Utilities" />
import { IAnchorProps, ILinkProps } from "./Link.Props";

/**
 * Handles an href and target being passed to an anchor, without a rel.
 */
export function getDefaultAnchorProps(anchorProps: IAnchorProps | undefined): IAnchorProps | undefined {
    let modifiedAnchorProps: IAnchorProps | undefined;

    if (anchorProps) {
        let rel = anchorProps.rel;
        if (anchorProps.href && anchorProps.target && !rel) {
            rel = "noopener";
        }
        modifiedAnchorProps = {
            href: anchorProps.href,
            rel: rel,
            target: anchorProps.target
        };
    }
    return modifiedAnchorProps;
}

/**
 * Handles an href and target being passed to a link, without a rel.
 */
export function getDefaultLinkProps(linkProps: ILinkProps | undefined): ILinkProps | undefined {
    if (!linkProps) {
        return getDefaultAnchorProps(linkProps);
    }

    return {
        ...getDefaultAnchorProps(linkProps),
        disabled: linkProps.disabled,
        id: linkProps.id,
        onClick: linkProps.onClick,
        role: linkProps.role
    };
}
